import {
  GET_BUSINESS_TYPE,
  GET_BUSINESS_TYPE_SUCCESS,
  GET_BUSINESS_TYPE_ERROR,

  GET_BUSINESS_TYPE_BY_ID,
  GET_BUSINESS_TYPE_BY_ID_SUCCESS,
  GET_BUSINESS_TYPE_BY_ID_ERROR,

  CREATE_BUSINESS_TYPE,
  CREATE_BUSINESS_TYPE_SUCCESS,
  CREATE_BUSINESS_TYPE_ERROR,

  UPDATE_BUSINESS_TYPE,
  UPDATE_BUSINESS_TYPE_SUCCESS,
  UPDATE_BUSINESS_TYPE_ERROR,

  DELETE_BUSINESS_TYPE,
  DELETE_BUSINESS_TYPE_SUCCESS,
  DELETE_BUSINESS_TYPE_ERROR

} from "../actions/businessTypeAction";

const initialState = {
  businessTypes: [], //THIS IS UESED FOR TO HOLD ARRAY DATA
  data: {}, // THIS IS USED FOR TO HOLD SAVE DATA
  loading: false,
  loaded: false,
  saving: false,
  saved: false,
  updating: false,
  updated: false,
  deleting: false,
  deleted: false,
  error: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_BUSINESS_TYPE:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };

    case GET_BUSINESS_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        businessTypes: action.payload.success,
      };

    case GET_BUSINESS_TYPE_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload.error,
        businessTypes: [],
      };


    case GET_BUSINESS_TYPE_BY_ID:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };

    case GET_BUSINESS_TYPE_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        businessTypes: action.payload.success,
      };

    case GET_BUSINESS_TYPE_BY_ID_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload.error,
        businessTypes: [],
      };


    case CREATE_BUSINESS_TYPE:
      return {
        ...state,
        saving: true,
        saved: false,
        error: null,
      };

    case CREATE_BUSINESS_TYPE_SUCCESS:
      return {
        ...state,
        saving: false,
        saved: true,
        data: action.payload.success,
      };

    case CREATE_BUSINESS_TYPE_ERROR:
      return {
        ...state,
        saving: false,
        saved: false,
        error: action.payload.error,
        data: {},
      };


    case UPDATE_BUSINESS_TYPE:
      return {
        ...state,
        updating: true,
        updated: false,
        error: null,
      };

    case UPDATE_BUSINESS_TYPE_SUCCESS:
      return {
        ...state,
        updating: false,
        updated: true,
        data: action.payload.success,
      };

    case UPDATE_BUSINESS_TYPE_ERROR:
      return {
        ...state,
        updating: false,
        updated: false,
        error: action.payload.error,
        data: {},
      };

      
    case DELETE_BUSINESS_TYPE:
      return {
        ...state,
        deleting: true,
        deleted: false,
        error: null,
      };

    case DELETE_BUSINESS_TYPE_SUCCESS:
      return {
        ...state,
        deleting: false,
        deleted: true,
        data: action.payload.success,
      };

    case DELETE_BUSINESS_TYPE_ERROR:
      return {
        ...state,
        deleting: false,
        deleted: false,
        error: action.payload.error,
        data: {},
      };

    default:
      return state;
  }
}
